import {Logger} from '@hopin/logger';

const logger = new Logger();
logger.setPrefix('[@hopin/markdown]');
export {logger};